import api from '@/services/api'
import { error } from 'shelljs'

const getters = {}

const actions = {
  edit({ commit }, data) {
    return new Promise((resolve, reject) => {
      api().post('/customer/site/indicatorFormulas', data.list).then( (response) => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  formulas({ commit }, data) {
    return new Promise((resolve, reject) => {
      api().get('/indicatorFormulas').then( (response) => {
        resolve(response.data.data)
      })
    })
  }
}

export default {
  namespaced: true,
  getters,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/indicators.js